export const VIDEO_CONTAINER_CLASSES = 'videoplayerjs video-stream-container '
export const VIDEO_FULL_ROUNDED_CONTAINER_CLASSES = 'full-rounded '
export const VIDEO_BOTTOM_ROUNDED_CONTAINER_CLASSES = 'bottom-rounded '

export const VIDEO_ELEVATED_CONTAINER_CLASSES = 'elevated '
export const VIDEO_ZOOMED_CONTAINER_CLASSES = 'zoom-video '
export const VIDEO_CONTAINER_PREFIX_ID = 'video-container-'
export const VIDEO_PLAYER_ID = 'video-{{ID}}_html5_api'
export const VIDEO_CONTAINER_CLASS = 'videoplayerjs'
export const FULL_WINDOW_CLASS = 'vjs-full-window'
